// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Navbar {\n  display: flex;\n  flex-direction: row; }\n  .Navbar .Navbar__spacer {\n    flex: 1 1; }\n  .Navbar .Navbar__admin {\n    background: aliceblue; }\n  .Navbar .Navbar__admin-header {\n    text-align: center; }\n  .Navbar .Navbar__list {\n    display: flex;\n    margin: 0;\n    list-style: none;\n    padding: 0; }\n  .Navbar .Navbar__item {\n    margin: 0 8px; }\n", ""]);
// Exports
module.exports = exports;
